export default __webpack_public_path__ + "static/media/factory.9e8bdd6b.jpg";